import { render, staticRenderFns } from "./InputPage.vue?vue&type=template&id=1373f48e&"
import script from "./InputPage.vue?vue&type=script&lang=ts&"
export * from "./InputPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports